import { ConfigProvider, Skeleton } from 'antd'
import { colors } from '../../services/style'

export const SL_Skeleton = ({ type, rows, ...rest }) => {
    const renderSkeleton = () => {
        switch (type) {
            case 'report':
                return <div className='flex gap-1 flex-col'>
                    {Array.from({ length: rows }).map((row, index) => <Skeleton.Input key={`skeleton-${index}`} {...rest} />)}
                </div>
            default:
                return (
                    <Skeleton
                        {...rest}
                        paragraph={{
                            rows,
                        }}
                    />
                )
        }
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    Skeleton: {
                        gradientToColor: colors['sl-gray'][400],
                        gradientFromColor: colors['sl-gray'][150],
                    },
                },
            }}
        >
            {renderSkeleton()}
        </ConfigProvider>
    )
}
